import { getCurrentPlan, hasLogRocket } from 'conversations/modules/gates/selectors'
import { isRunningInDesktop } from 'conversations/utils/PlatformUtil'

import { DriftAnalytics } from '@driftt/dds.analytics'
import { GlobalStore as store } from '@driftt/traffic-control'

const getTagInformation = () => ({
  plan: getCurrentPlan(store.getState()),
  isDesktop: isRunningInDesktop,
})

export const captureMessage = (message: string, extra = {}) => {
  const hasLR = hasLogRocket(store.getState())
  hasLR && DriftAnalytics.captureException(message, { extra, tags: getTagInformation() })
}

export const captureError = (err: Error | any, errMessage: string, extra = {}) => {
  const hasLR = hasLogRocket(store.getState())
  hasLR &&
    DriftAnalytics.captureException(new Error(errMessage, { cause: err }), {
      extra,
      tags: getTagInformation(),
    })
}
